import { render, staticRenderFns } from "./RecordBlock.vue?vue&type=template&id=5bfcdbe6"
import script from "./RecordBlock.vue?vue&type=script&lang=js"
export * from "./RecordBlock.vue?vue&type=script&lang=js"
import style0 from "./RecordBlock.vue?vue&type=style&index=0&id=5bfcdbe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports